import { useState } from "react";
import { Instagram } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { GALLERY, INSTAGRAM, HANDLE } from "@/data/site";
import { imgPos } from "@/lib/api";

export default function Gallery() {
  const [open, setOpen] = useState(null);
  return (
    <main data-testid="gallery-page">
      <PageHero eyebrow="Gallery" lines={["A look inside", <span className="italic text-mocha">the studio.</span>]} intro={`More on Instagram at ${HANDLE}.`} />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={(i % 3) * 0.06} className="break-inside-avoid">
              <button data-testid={`gallery-item-${i}`} onClick={() => setOpen(g)} className={`group relative block w-full overflow-hidden ${i % 3 === 1 ? "aspect-[3/4]" : i % 3 === 2 ? "aspect-square" : "aspect-[4/5]"}`}>
                <img src={g.src} alt={g.alt} className={`absolute inset-0 w-full h-full object-cover ${imgPos(g.src)} transition-transform duration-[1.4s] group-hover:scale-105`} />
              </button>
            </Reveal>
          ))}
        </div>
        <div className="mt-16 text-center">
          <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="gallery-instagram-cta" className="btn btn-dark"><Instagram className="w-4 h-4" strokeWidth={1.4} />Follow {HANDLE}</a>
        </div>
      </section>
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-4xl p-0 bg-cream border-0 overflow-hidden">
          <DialogTitle className="sr-only">{open?.alt}</DialogTitle>
          {open && <img src={open.src} alt={open.alt} className="w-full max-h-[85vh] object-contain bg-[#F1EDE4]" />}
        </DialogContent>
      </Dialog>
    </main>
  );
}
